var App = App || {};

App.AutoDealerships = (function ($) {
    "use strict";

    const fallbackZip = "06108";

    function Init(selector) {
        selector.each(function () {
            var $this = $(this),
                $make = $this.find("#make"),
                $radius = $this.find("#radius"),
                $miles = $this.find("#miles"),
                $of = $this.find("#of"),
                $location = $this.find("#location"),
                $getUserZip = $this.find("#getUserZip"),
                $submit = $this.find("#autoDealershipSubmit");

            setRadius($radius, $miles, $of);
            setUserZip($location);

            if (!$location.val()) {
                setCurrentZip($location);
            }

            $getUserZip.on("click", function (e) {
                e.preventDefault();

                setCurrentZip($location);
            });

            $submit.on("click", function (e) {
                e.preventDefault();

                const zip = $location.val().trim();
                const zipPattern = /^\d{5}(-\d{4})?$/;

                if (!zipPattern.test(zip)) {
                    $location[0].setCustomValidity("Enter a 5-digit ZIP code or ZIP+4 (e.g. 12345 or 12345-6789)");
                    $location[0].reportValidity();
                    return;
                } else {
                    $location[0].setCustomValidity("");
                }

                var querystring = "";

                // Makes
                var selectedMakes = [];
                var selectedMakesInput = $make.find(".dropdown-menu input:checked"),
                    selectedMakesQs = "",
                    url = window.location.origin + window.location.pathname;

                $.each(selectedMakesInput, function () {
                    selectedMakes.push($(this).val());
                });

                selectedMakesQs = "automake=" + encodeURIComponent(
                    selectedMakes.map(function (make) {
                        return "AutoMakes_" + make.replace(/\s+/g, "");
                    }).join(",")
                );

                if (selectedMakesQs) {
                    querystring += (querystring.length > 0 ? '&' : '') + selectedMakesQs;
                }

                // Radius
                var radius = $radius.val();

                if (radius) {
                    querystring += (querystring.length > 0 ? '&' : '') + "radius=" + radius;
                }

                // ZIP code
                if (zip) {
                    querystring += (querystring.length > 0 ? '&' : '') + "zip=" + zip;

                    google.maps.importLibrary("geocoding").then(() => {
                        var geocoder = new google.maps.Geocoder();

                        geocoder.geocode({ 'address': zip, componentRestrictions: { country: "US" } }, function (results, status) {
                            if (status == google.maps.GeocoderStatus.OK) {
                                var lat = results[0].geometry.location.lat();
                                var lng = results[0].geometry.location.lng();

                                if (lat && lng) {
                                    querystring += '&lat=' + lat + '&lng=' + lng;
                                }
                            }
                            window.open(url + '?' + querystring + "#" + $this.attr('id'), '_self');
                        });
                    });
                } else {
                    window.open(url + '?' + querystring + "#" + $this.attr('id'), '_self');
                }
            });
        });
    }

    function setRadius($radius, $miles, $of) {
        const params = new URLSearchParams(window.location.search);
        const radiusParam = params.get("radius");

        if (radiusParam !== null) {
            $radius.val(radiusParam);
        }

        const initialValue = $radius.val();

        if (initialValue > 250) {
            $miles.text("Nationwide");
            $of.hide();
        } else {
            $miles.text(initialValue + " miles");
            $of.show();
        }

        $radius.on("change input", function (e) {
            const value = e.target.value;

            if (value > 250) {
                $miles.text("Nationwide");
                $of.hide();
            } else {
                $miles.text(value + " miles");
                $of.show();
            }
        });
    }

    function setCurrentZip($location) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                function (position) {
                    if (position.coords) {
                        const latlng = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };

                        google.maps.importLibrary("geocoding").then(() => {
                            const geocoder = new google.maps.Geocoder();

                            geocoder.geocode({ location: latlng }, function (results, status) {
                                if (status === "OK" && results[0]) {
                                    let zipFound = false;

                                    $.each(results[0].address_components, function () {
                                        if (this.types.includes("postal_code")) {
                                            $location.val(this.long_name);
                                            zipFound = true;

                                            return false;
                                        }
                                    });

                                    if (!zipFound) {
                                        $location.val(fallbackZip);
                                    }
                                } else {
                                    $location.val(fallbackZip);
                                }
                            });
                        });
                    }
                },
                function (error) {
                    $location.val(fallbackZip);
                }
            );
        } else {
            $location.val(fallbackZip);
        }
    }

    function setUserZip($location) {
        const params = new URLSearchParams(window.location.search);
        const zipParam = params.get("zip");

        if (zipParam !== null && zipParam.trim() !== "") {
            $location.val(zipParam);
        }
    }

    return {
        Init: Init
    };
})(jQuery);